import { useUserStore } from '@stores/user.store'

import Image from 'next/image'

import UserIconPlaceholder from '@images/navbar/user-icon.svg'

import styles from './avatar.module.scss'

export default function Avatar(): JSX.Element {
  const { user } = useUserStore((st) => st.profile)

  if (user?.profilePicUrl) {
    // eslint-disable-next-line @next/next/no-img-element
    return <img src={user?.profilePicUrl} alt="Profile Picture" width={35} height={35} className={styles.image} />
  }

  return <Image src={UserIconPlaceholder} alt="Profile Picture" width={23} height={23} className={styles.palceholder} />
}
